// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PreviewWrapper_wrapper__3kfhY","desktop":"PreviewWrapper_desktop__27d0v","phone":"PreviewWrapper_phone__3mnHU","tablet":"PreviewWrapper_tablet__-7A-L"};